<template>
  <div class="register-page" :style="registerBgStyle">
    <el-dropdown class="custom-dropdown" popper-class="custom-dropdown-popper">
      <span class="el-dropdown-link custom-dropdown-link" style="border: none !important; box-shadow: none !important;">
        <GlobalIcon/>

        <span :style="{ color: 'white', 'margin-right': '10px' }"> {{ $t('settingPage.language') }}</span>
        <el-icon
            style="color: white;font-size: 10px;">
          <ArrowDown/>
        </el-icon>
      </span>
      <template #dropdown>
        <el-dropdown-menu>
          <el-dropdown-item v-for="(language, friendlyName) in supportedLanguages" :key="friendlyName"
                            @click="changeLanguage(friendlyName)" @mouseenter="hover = friendlyName"
                            @mouseleave="hover = null"
                            :style="hover === friendlyName ? 'color: rgb(80,80,80); background-color: rgb(245,245,245);' : 'color: rgb(80,80,80); font-size:14px;background-color: transparent;'">
            {{ 
              friendlyName 
            }}
          </el-dropdown-item>
        </el-dropdown-menu>
      </template>
    </el-dropdown>

    <div class="register-container">
      <div class="left-pane">
        <img id="register-left" :src="require('@/assets/image/left_logo.png')" alt="Logo"/>
        <div class="left-text">{{ $t('LoginPage.onlineServicePlatform') }}</div>
      </div>
      <div class="right-pane">
        <div class="main-form">
          <h2 class="h2-text">Ananda Link {{ $t('LoginPage.accountApplicationForm') }}</h2>
          <el-form ref="registerForm" :model="registerData" :rules="registerFormRules" label-width="100px" label-position="top">
            <div class="form-row">
              <el-form-item :label="$t('RegisterPage.companyName')" prop="company">
                <el-input class="other-input" v-model="registerData.company" :placeholder="$t('RegisterPage.enterCompanyName')">
                </el-input>
              </el-form-item>
              <el-form-item :label="$t('RegisterPage.applicant')" prop="name">
                <el-input class="other-input" v-model="registerData.name" :placeholder="$t('RegisterPage.enterApplicant')">
                </el-input>
              </el-form-item>
            </div>
            <div class="form-row">
              <el-form-item :label="$t('RegisterPage.country')" prop="country_id">
                <el-select class="other-input" v-model="registerData.country_id" :placeholder="$t('RegisterPage.selectCountry')" filterable clearable style="height: 48px; width: 100%;">
                  <el-option v-for="country in countryOptions" :key="country.value" :label="country.label" :value="country.value"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('RegisterPage.location')" prop="address">
                <el-input class="other-input" v-model="registerData.address" :placeholder="$t('RegisterPage.enterLocation')">
                </el-input>
              </el-form-item>
            </div>
            <el-form-item :label="$t('RegisterPage.companyAddress')" prop="company_address">
              <el-input type="textarea" class="other-input textarea-input" v-model="registerData.company_address" :placeholder="$t('RegisterPage.enterCompanyAddress')" :rows="3">
              </el-input>
            </el-form-item>
            <div class="form-row">
              <el-form-item :label="$t('RegisterPage.email')" prop="email">
                <el-input class="other-input" v-model="registerData.email" :placeholder="$t('RegisterPage.enterEmail')">
                </el-input>
              </el-form-item>
              <el-form-item :label="$t('RegisterPage.phoneNumber')" prop="phoneNumber">
                <el-input class="other-input" v-model="registerData.phoneNumber" :placeholder="$t('RegisterPage.enterPhoneNumber')">
                </el-input>
              </el-form-item>
            </div>
            <div class="form-row">
              <el-form-item :label="$t('RegisterPage.verificationCode') + $t('RegisterPage.verificationCodeSentToEmail')" prop="code" style="width: 100%; margin-bottom: 12px;">
                <div class="verification-code-container">
                  <el-input class="other-input verification-code-input" v-model="registerData.code" :placeholder="$t('RegisterPage.enterVerificationCode')">
                  <template #prepend>
                    <el-icon class="larger-icon">
                      <Message/>
                    </el-icon>
                  </template>
                </el-input>
                  <el-button class="verification-code-button" @click="getVerificationCode" :disabled="countdown > 0 || isSending">
                    {{ countdownMessage }}
                  </el-button>
                </div>
              </el-form-item>
            </div>

            <el-form-item :label="$t('RegisterPage.manufacturer')" prop="manufacturer">
              <el-input type="textarea" class="other-input textarea-input" v-model="registerData.manufacturer" :placeholder="$t('RegisterPage.enterManufacturer')" :rows="3">
              </el-input>
            </el-form-item>

            <el-button class="register-button button-background-color" @click="register"
                       :disabled="isLoading">
              <span v-if="!isLoading">{{ $t('RegisterPage.submit') }}</span>
              <span v-else>
    <i class="el-icon-loading"></i>
    {{ $t('RegisterPage.submitting') }}
  </span>
            </el-button>

          </el-form>
        </div>

      </div>
    </div>

  </div>

  <!-- 免责提示框 -->
  <el-dialog v-model="disclaimerDialogVisible" width="600" align-center center>
    <div class="disclaimer-content" style="font-size: 16px; line-height: 1.5; color: red; font-weight: bold;">
      {{ $t('RegisterPage.disclaimer') }}
    </div>
    <template #footer>
      <div class="dialog-footer" style="display: flex; justify-content: center; gap: 20px;">
        <el-button @click="disclaimerDialogVisible = false" style="width: 100px;">
          {{ $t('RegisterPage.cancel') }}
        </el-button>
        <el-button type="primary" @click="handleDisclaimerAgree" style="width: 100px;">
          {{ $t('RegisterPage.confirm') }}
        </el-button>
      </div>
    </template>
  </el-dialog>
</template>

<script>
import {ArrowDown, Message} from "@element-plus/icons-vue";
import GlobalIcon from "@/components/GlobalIcon.vue";
import countryMixin from "@/mixins/countryMixin";
import { registerUser, sendMail } from "@/api/api";

export default {
  components: {ArrowDown, Message, GlobalIcon},
  mixins: [countryMixin],
  data() {
    return {
      registerData: {
        company: "",
        name: "",
        country_id: null,
        address: "",
        company_address: "",
        email: "",
        phoneNumber: "",
        manufacturer: "",
        code: ""
      },
      isLoading: false,
      disclaimerDialogVisible: false,
      countdown: 0,
      isSending: false,

      supportedLanguages: {
        '简体中文': 'zh',
        'English': 'en',
        'Italiano': 'it',
        'Francais': 'fr',
        'Deutsch': 'de',
        'Dutch': 'nl',
        '日本語': 'ja',
        'Svenska': 'sv',
        'Magyar': 'hu',
        'Polski': 'pl',
        'Español': 'es',
        'Português': 'pt'
      },
      selectedLanguage: this.$store.getters.currentLanguageFriendlyName,
      hover: null,
      registerFormRules: {
        company: [
          {required: true, message: this.$t('RegisterPage.enterCompanyName'), trigger: 'blur'},
        ],
        name: [
          {required: true, message: this.$t('RegisterPage.enterApplicant'), trigger: 'blur'},
        ],
        country_id: [
          {required: true, message: this.$t('RegisterPage.selectCountry'), trigger: 'blur'},
        ],
        address: [
          {required: true, message: this.$t('RegisterPage.enterLocation'), trigger: 'blur'},
        ],
        company_address: [
          {required: true, message: this.$t('RegisterPage.enterCompanyAddress'), trigger: 'blur'},
        ],
        email: [
          {required: true, message: this.$t('RegisterPage.enterEmail'), trigger: 'blur'},
          {type: 'email', message: this.$t('RegisterPage.invalidEmail'), trigger: 'blur'},
        ],
        phoneNumber: [
          {required: true, message: this.$t('RegisterPage.enterPhoneNumber'), trigger: 'blur'},
        ],
        manufacturer: [
          {required: true, message: this.$t('RegisterPage.enterManufacturer'), trigger: 'blur'},
        ],
        code: [
          {required: true, message: this.$t('RegisterPage.enterVerificationCode'), trigger: 'blur'},
        ]
      },
    };
  },
  computed: {
    countdownMessage() {
      if (this.countdown > 0) {
        return `${this.$t('RegisterPage.wait')} ${this.countdown} s`;
      } else {
        return this.$t('RegisterPage.getVerificationCode');
      }
    },
    verificationCodeInputWidth() {
      // 返回一个固定宽度，与邮箱输入框一致
      return '100%';
    },
    registerBgStyle() {
      return {
        backgroundImage: `linear-gradient(270.06deg, rgba(36, 81, 26, 0.5) 0.04%, rgba(5, 26, 0, 0.5) 101.39%),
        url(https://trae-api-cn.mchost.guru/api/ide/v1/text_to_image?prompt=A%20mountain%20biker%20jumping%20on%20a%20trail%20in%20autumn%20forest%20with%20yellow%20and%20orange%20leaves%2C%20dynamic%20action%20shot%2C%20high%20quality%20photography&image_size=landscape_16_9)`
      }
    }
  },
  watch: {
    '$i18n.locale'() {
      this.registerFormRules = {
        company: [
          {required: true, message: this.$t('RegisterPage.enterCompanyName'), trigger: 'blur'},
        ],
        name: [
          {required: true, message: this.$t('RegisterPage.enterApplicant'), trigger: 'blur'},
        ],
        country_id: [
          {required: true, message: this.$t('RegisterPage.selectCountry'), trigger: 'blur'},
        ],
        address: [
          {required: true, message: this.$t('RegisterPage.enterLocation'), trigger: 'blur'},
        ],
        company_address: [
          {required: true, message: this.$t('RegisterPage.enterCompanyAddress'), trigger: 'blur'},
        ],
        email: [
          {required: true, message: this.$t('RegisterPage.enterEmail'), trigger: 'blur'},
          {type: 'email', message: this.$t('RegisterPage.invalidEmail'), trigger: 'blur'},
        ],
        phoneNumber: [
          {required: true, message: this.$t('RegisterPage.enterPhoneNumber'), trigger: 'blur'},
        ],
        manufacturer: [
          {required: true, message: this.$t('RegisterPage.enterManufacturer'), trigger: 'blur'},
        ],
        code: [
          {required: true, message: this.$t('RegisterPage.enterVerificationCode'), trigger: 'blur'},
        ]
      };
    }
  },
  mounted() {
    // 优先从 URL 参数获取语言设置
    const urlParams = new URLSearchParams(window.location.search);
    const urlLang = urlParams.get('lang');
    
    // 如果 URL 中有语言参数且有效，则使用该语言
    if (urlLang && Object.values(this.supportedLanguages).includes(urlLang)) {
      // 找到对应的友好名称
      const friendlyName = Object.keys(this.supportedLanguages).find(key => this.supportedLanguages[key] === urlLang);
      if (friendlyName) {
        this.selectedLanguage = friendlyName;
        this.changeLanguage(this.selectedLanguage);
      }
    } else {
      // 否则从 localStorage 获取
      const lang = localStorage.getItem('lang');
      if (lang && this.supportedLanguages[lang]) {
        this.selectedLanguage = lang;
        this.changeLanguage(this.selectedLanguage);
      } else {
        this.selectedLanguage = 'English';
        this.changeLanguage(this.selectedLanguage);
      }
    }
    this.$nextTick(() => {
      if (this.$refs.registerForm) {
        this.$refs.registerForm.validateOnRuleChange = false;
      }
    });
    
    this.fetchCountryOptions();

  },
  methods: {


    async getVerificationCode() {
      if (this.countdown > 0 || this.isSending) return; // 如果在倒计时期间或正在发送，禁止重复点击
      this.isSending = true; // 设置发送锁
      try {
        // 验证邮箱格式
        const emailRule = this.registerFormRules.email;
        let isValid = true;
        for (const rule of emailRule) {
          if (rule.type === 'email') {
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (!emailRegex.test(this.registerData.email)) {
              this.$message.error(this.$t('RegisterPage.invalidEmail'));
              isValid = false;
              break;
            }
          } else if (rule.required && !this.registerData.email) {
            this.$message.error(this.$t('RegisterPage.enterEmail'));
            isValid = false;
            break;
          }
        }

        if (!isValid) {
          return;
        }

        // 发送验证码
        const response = await sendMail(this.registerData.email);
        if (response.code === 0) {
          this.$message.success(this.$t('RegisterPage.verificationCodeSent'));
          // 开始倒计时
          this.startCountdown();
        } else {
          this.$message.error(response.message || this.$t('RegisterPage.failedToSendCode'));
        }
      } catch (error) {
        console.error('Error sending verification code:', error);
        this.$message.error(this.$t('RegisterPage.failedToSendCode'));
      } finally {
        this.isSending = false; // 无论成功失败，都释放发送锁
      }
    },
    
    startCountdown() {
      this.countdown = 59; // 60秒倒计时
      const timer = setInterval(() => {
        if (this.countdown > 0) {
          this.countdown--;
        } else {
          clearInterval(timer);
        }
      }, 1000);
    },
    
    async register() {
      try {
        await this.$refs.registerForm.validate();

        // 显示免责提示框
        this.disclaimerDialogVisible = true;

      } catch (error) {
        console.error('Registration error:', error);
        if (error.response) {
          this.$message.error(error.response.data?.message || this.$t('RegisterPage.registrationFailed'));
        } else {
          this.$message.error(this.$t('RegisterPage.registrationFailed'));
        }
      }
    },
    
    changeLanguage(friendlyName) {
      this.selectedLanguage = friendlyName;
      const language = this.supportedLanguages[friendlyName];
      this.$store.dispatch('changeLanguage', {language, friendlyName});
    },
    
    async handleDisclaimerAgree() {
      try {
        this.isLoading = true;
        
        const response = await registerUser({
          email: this.registerData.email,
          name: this.registerData.name,
          country_id: this.registerData.country_id,
          company: this.registerData.company,
          company_address: this.registerData.company_address,
          address: this.registerData.address,
          phoneNumber: this.registerData.phoneNumber,
          manufacturer: this.registerData.manufacturer,
          code: this.registerData.code
        });

        if (response.code === 0) {
          this.disclaimerDialogVisible = false;
          this.$message.success(this.$t('RegisterPage.registrationSuccess'));
          this.$router.push('/LoginPage');
        } else {
          this.$message.error(response.message || this.$t('RegisterPage.registrationFailed'));
          this.disclaimerDialogVisible = false;
        }

      } catch (error) {
        console.error('Registration error:', error);
        if (error.response) {
          this.$message.error(error.response.data?.message || this.$t('RegisterPage.registrationFailed'));
        } else {
          this.$message.error(this.$t('RegisterPage.registrationFailed'));
        }
        this.disclaimerDialogVisible = false;
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>

<style scoped>
.terms-link {
  margin-left: 10px;
}

.larger-icon {
  font-size: 16px;
  color: black;
}

:deep( .verification-code-input .el-input-group__prepend ) {
  background-color: rgb(255, 255, 255);
  border: none;
}

:deep(.verification-code-input .el-input__inner ) {
  border-left: none;
}

:deep( .custom-input .el-input-group__prepend ) {
  background-color: rgb(255, 255, 255);
  border: none;
}

:deep(.custom-input .el-input__inner) {
  border-left: none;
}

:deep(.other-input .el-input-group__prepend ) {
  background-color: rgb(255, 255, 255);
  border: none;
}

:deep(.other-input .el-input__inner ) {
  border-left: none;
}

.other-input {
  height: 48px;
  line-height: 48px;
  font-size: 16px;
}

/* 验证码输入框和按钮样式 */
.verification-code-container {
  display: flex;
  align-items: center;
  width: 100%;
}

.verification-code-input {
  flex: 1;
  width: 100%;
  min-width: 0;
}

.verification-code-button {
  margin-left: 10px;
  height: 48px;
  min-width: 120px;
  flex-shrink: 0;
  white-space: nowrap;
  padding: 0 15px;
}

/* 确保验证码输入框所在的form-item宽度与邮箱输入框一致 */
.form-row .el-form-item {
  width: 100%;
}

/* 确保验证码输入框容器宽度与其他输入框一致 */
.form-row .el-form-item .verification-code-container {
  width: 100%;
}

/* 调整下拉框高度与输入框一致 */
.form-row .el-form-item :deep(.other-input.el-select) {
  height: 48px !important;
  width: 100% !important;
  border: 1px solid #dcdfe6 !important;
  border-radius: 4px !important;
}

.form-row .el-form-item :deep(.other-input.el-select:hover) {
  border-color: #c0c4cc !important;
}

.form-row .el-form-item :deep(.other-input.el-select:focus-within) {
  border-color: #009a44 !important;
  outline: 0 !important;
  box-shadow: 0 0 0 2px rgba(0, 154, 68, 0.2) !important;
}

.form-row .el-form-item :deep(.other-input.el-select .el-input) {
  height: 100% !important;
  width: 100% !important;
}

.form-row .el-form-item :deep(.other-input.el-select .el-input__wrapper) {
  height: 100% !important;
  line-height: 48px !important;
  width: 100% !important;
  border: none !important;
  box-shadow: none !important;
  padding: 0 !important;
}

.form-row .el-form-item :deep(.other-input.el-select .el-input__inner) {
  height: 100% !important;
  line-height: 48px !important;
  width: 100% !important;
  padding: 0 15px !important;
  font-size: 16px !important;
  border: none !important;
  box-shadow: none !important;
}

.form-row .el-form-item :deep(.other-input.el-select .el-input__suffix) {
  height: 100% !important;
  display: flex !important;
  align-items: center !important;
  padding-right: 15px !important;
}

.textarea-input {
  min-height: 96px;
  font-size: 16px;
  resize: vertical;
}

.register-page {
  display: flex;
  align-items: center;
  justify-content: center;
  height: calc(100% + 48px);
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;

  position: relative;
  overflow-x: auto;
}

.register-container {
  position: relative;
  display: flex;
  align-items: center;
  border-radius: 8px;
  overflow: hidden;
  min-width: 1200px;
  width: 100%;
}

.left-pane {
  margin-left: 120px;
  padding-left: 20px;
}

.left-text {
  color: rgb(255, 255, 255);
  font-size: 36px;
  font-family: "PingFang SC", Arial, sans-serif;
  width: 360px;
  height: 40px;
  margin-top: 20px;
  white-space: nowrap;
}

#register-left {
  width: 700px;
  height: 63px;
}

.right-pane {
  background-color: #ffffff;
  padding: 20px 30px;

  width: 50%;
  max-width: 900px;
  display: flex;
  justify-content: center;
  right: 0;
  z-index: 1;
  border-radius: 8px;
  margin: 0 auto;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
}

.main-form {
  width: 100%;
  max-width: 720px;
}

.main-form .el-form-item .el-input {
  width: 100%;
}

.h2-text {
  font-size: 36px;
  font-weight: bold;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
  width: 100%;
  height: 48px;
  margin-bottom: 30px;
  margin-top: 0;
  white-space: normal;
  text-align: center;
  color: #333;
}

.form-row {
  display: flex;
  gap: 12px;
  margin-bottom: 12px;
}

.el-form-item {
  margin-bottom: 12px !important;
}

.form-row .el-form-item {
  flex: 1;
  margin-bottom: 0 !important;
}

.privacy-agreement {
  text-align: left;
  margin-bottom: 16px;
}

.privacy-agreement span,
.privacy-agreement a {
  white-space: normal;
  line-height: 1.5;
}

.register-button {
  width: 100%;
  height: 50px;
  padding: 10px 20px;
  margin: 20px 0 0 0;
  font-size: 18px;
  font-weight: bold;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
  border-radius: 4px;
  transition: all 0.3s ease;
}

.register-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 154, 68, 0.3);
}

/* 禁用状态下的登录按钮样式 */
.el-button.register-button:disabled {
  background-color: rgb(245, 245, 245) !important;
  color: rgb(184, 184, 184) !important;
}

.el-dropdown-link {
  cursor: pointer;
  color: var(--el-color-primary);
  display: flex;
  align-items: center;
}

.custom-dropdown {
  position: absolute;
  top: 20px;
  right: 30px;
  z-index: 100;
}

:deep( .el-form-item__label ) {
  margin-bottom: 0;
  padding-bottom: 0;
}

.input-with-button {
  display: flex;
  align-items: center;
}

.input-with-button .el-input,
.input-with-button .el-button {
  flex-shrink: 0;
}

.input-with-button .el-input {
  margin-right: 10px;
}

:deep(.custom-input .el-input__inner ) {
  height: 40px;
  line-height: 40px;
  width: 130px;
}

.input-with-button .custom-button {
  height: 40px;
  line-height: 40px;
}

.custom-reset-button {
  white-space: nowrap;
}
</style>